<template>
  <div class="">
    <h3 class="mb-0">Fedezze fel partnereink által kínált lehetőségeket!</h3>
    <div class="carousel-wrapper">
      <carousel
        class="carousel-box"
        :per-page="2"
        :mouse-drag="true"
        :perPageCustom="responsiveCarouselSetting"
        :navigationEnabled="false"
        :autoplay="false"
        :loop="true"
        :autoplayTimeout="5000"
        paginationActiveColor="#3ba7de"
        paginationColor="#C4C4C4"
        :paginationSize="20"
      >
        <slide>
          <div class="opportinity-wrap grow" @click="exim">
            <b-img class="opportunity-image" src="../../assets/img/opportunity/exim.svg"></b-img>
            <p class="text-green font-weight-bold pb-3">Export Bank Biztosító</p>
          </div>
        </slide>
        <slide>
          <div class="opportinity-wrap grow" @click="szechenyi">
            <b-img class="opportunity-image" src="../../assets/img/opportunity/szechenyi.svg"></b-img>
            <p class="text-green font-weight-bold pb-3">Széchenyi Kártya hitelek</p>
          </div>
        </slide>
        <slide>
          <div class="opportinity-wrap grow" @click="mfb">
            <b-img class="opportunity-image" src="../../assets/img/opportunity/mfb.svg"></b-img>
            <p class="text-green font-weight-bold pb-3">Magyar Fejlesztési Bank</p>
          </div>
        </slide>
        <slide>
          <div class="opportinity-wrap grow" role="presentation" @click="goToVoszPort">
            <b-img class="opportunity-image pt-5" src="../../assets/img/voszport-logo.png"></b-img>
            <p class="text-green font-weight-bold pb-3">VOSZPort</p>
          </div>
        </slide>
      </carousel>
    </div>
    <b-modal id="voszport-terminated-modal" hide-header hide-footer centered title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center title mb-5"><strong> Sikertelen bejelentkezés!</strong></h1>
        <p class="ml-2 mr-2 d-flex justify-content-center">
          A VOSZPort oldali felhasználó felfüggesztésre került! Ezért a belépés a VOSZPort felületére nem lehetséges.
          Kérjük, vegye fel a kapcsolatot a voszport.hu oldalon az „Írjon nekünk” funkcióval, hogy további segítséget
          nyújthassunk Önnek.
          <br />
          <br />
          Üdvözlettel a VOSZPort csapata!
        </p>
        <div class=" d-flex justify-content-center">
          <b-button class="col-3" @click="closeTerminatedModal">Rendben</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'
import * as VoszportApi from '../../api/voszport'

export default {
  name: 'PartnerOpportunities',
  components: {
    Carousel,
    Slide
  },
  data: function() {
    return {
      exim: () => this.$router.push('/export-bank-biztosito'),
      szechenyi: () => this.$router.push('/szechenyi-kartya-hitelek'),
      mfb: () => this.$router.push('/magyar-fejlesztesi-bank'),
      responsiveCarouselSetting: [
        [320, 1],
        [768, 2],
        [992, 3],
        [1200, 4]
      ]
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'getUser'])
  },
  methods: {
    openLoginModal() {
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    async goToVoszPort() {
      if (!this.isAuthenticated) {
        return this.openLoginModal()
      }
      const status = await this.getStatus(this.getUser.email)
      if (status === 'EXIST') {
        const redirectUrl = await this.getLoginRedirectUrl(this.getUser.email)
        window.open(redirectUrl, '_blank')
      }

      if (status === 'NOT_EXIST') {
        const redirectUrl = await this.getRegistRedirectUrl(this.getUser._id)
        window.open(redirectUrl, '_blank')
      }

      if (status === 'SUSPENDED' || status === 'TEMPORALLY_DISABLED') {
        this.openTerminatedModal()
      }

      if (status === 'NO_RESPONSE') {
        window.open('https://voszport.hu', '_blank')
        // errortoast
      }
    },
    async getStatus(email) {
      try {
        const status = await VoszportApi.getStatus(email)
        return status
      } catch (error) {
        console.log(error)
      }
    },
    async getLoginRedirectUrl(email) {
      try {
        const redirectUrl = await VoszportApi.getLoginRedirectUrl(email)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    async getRegistRedirectUrl(userId) {
      try {
        const redirectUrl = await VoszportApi.getRegistRedirectUrl(userId)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    openTerminatedModal() {
      this.$root.$emit('bv::show::modal', 'voszport-terminated-modal')
    },
    closeTerminatedModal() {
      this.$root.$emit('bv::hide::modal', 'voszport-terminated-modal')
    }
  }
}
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  justify-content: center;
}
.carousel-box {
  max-width: 1200px;
}
@media all and (max-width: 1200px) {
  .carousel-box {
    max-width: 875px;
  }
}

.opportinity-wrap {
  margin: 36px;
  width: 220px;
  height: 235px;
  background: #ffffff;
  border: 1px solid #dfe6e9;
  box-shadow: 0px 4px 16px #b2bec3;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.opportunity-image {
  width: 100%;
  padding-top: 20px;
  padding-left: 45px;
  padding-right: 45px;
}

.grow {
  transition: all 0.2s ease-in-out;
}

.grow:hover {
  transform: scale(1.05);
  cursor: pointer;
}
@media (max-width: 992px) {
  .carousel-box {
    max-width: 648px;
  }
  .opportinity-wrap {
    width: 300px;
    height: 285px;
    margin: 13px;
  }
  .opportunity-image {
    padding-top: 15px;
    padding-left: 65px;
    padding-right: 65px;
  }
}

@media (max-width: 768px) {
  .carousel-box {
    max-width: 325px;
  }
}
</style>
